import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { filter, map } from "rxjs/operators";
import { ContenteditableDirective } from "../core/content-editable/contenteditable.directive";
import { PreviewEditTemplateActions } from "../preview-edit-template/state/preview-edit-template.actions";
import { PreviewEditTemplateSelectors } from "../preview-edit-template/state/preview-edit-template.selectors";
import { Subscription } from "rxjs/index";

@Component({
  selector: "email-message-new",
  styles: [`
    div.insert-parameter-dropdown {
      width: 60% !important;
      height: 36px !important;
      border: 1px solid #cccccc !important;
      background: white !important;
    }
  `],
  templateUrl: "./email-message-new.component.html",
  encapsulation: ViewEncapsulation.None
})
export class EmailMessageNewComponent implements OnInit, OnChanges, OnDestroy {
  @Input() mailContent;
  @Input() templateUpdateModel; // updatedModel renamed so we can use it with the ng-model coming from backend as it is
  @Input() templateParameters;
  @Input() isOnlyPreview;
  @Input() userPermissions;
  @Input() communicationsCategoryId;
  @Input() tabIndex;
  @Input() contextVariables;
  @Input() triggeredCategory;
  @Input() imageModel: Array<any>;

  selectedTemplateParameter: string;
  selectedIndex;
  selectedNode: any;
  displayTemplateParameters = [];
  template: any;
  selection: any;

  templateUpdateModel$: Observable<any>;
  preventChanges: boolean = false;
  _subscription: Subscription = new Subscription();

  _timeout: NodeJS.Timeout;

  constructor(
    public contenteditableDirective: ContenteditableDirective,
    private previewEditSelector: PreviewEditTemplateSelectors,
    private resolver: ComponentFactoryResolver,
    private store: Store<any>
  ) {
    this.templateUpdateModel$ =
      this.previewEditSelector.selectTemplateUpdateModel();

    this._subscription.add(
      this.previewEditSelector.selectGetEmailPreventChanges().subscribe(preventChanges => {
        this.preventChanges = preventChanges;

        if(this.preventChanges){
         this._timeout = setTimeout(()=>{
            this.store.dispatch(PreviewEditTemplateActions.setEmailPreventChanges({preventChanges: false}))
          }, 500)
        }
        })
    )
  }

  ngOnInit(): void {
    this.templateUpdateModel$ = this.previewEditSelector
      .selectTemplateUpdateModel()
      .pipe(
        filter((templateUpdateModel) => templateUpdateModel !== undefined),
        filter(
          (templateUpdateModel) =>
            templateUpdateModel.updatedModel !== undefined
        ),
        map((templateUpdateModel) => {
          // to avoid emailSubject cursor set to beginning
          if (
              (templateUpdateModel.updateType === "model" && this.selectedIndex !== 1 ) || // for email subject we are reloading the component html which moves the cursor to begin
            templateUpdateModel.updateType === "changeCategory" ||
            templateUpdateModel.updateType === "updatedJob" ||
            templateUpdateModel.updateType === "savedJob" ||
            templateUpdateModel.updateType === "copySourceToDB" ||
            templateUpdateModel.updateType === "setToDefault" ||
            templateUpdateModel.updateType === "imageUpload"
          ) {
              this.template = {...templateUpdateModel.updatedModel};
          }

          return templateUpdateModel;
        })
      );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    clearTimeout(this._timeout);
  }

  setSelectedIndex(e, selectedIndex): void {
    this.selectedNode = e.target;
    while (this.selectedNode.id === "") {
      this.selectedNode = this.selectedNode.parentNode;
    }
    this.selectedIndex = selectedIndex;

    // this is needed to enable cursor to  be displayed after template-context when last child
    if (
      this.selectedNode !== undefined &&
      this.selectedNode.lastChild !== undefined &&
      this.selectedNode.lastChild !== null &&
      this.selectedNode.lastChild.localName === "template-context"
    ) {
      const textnode = document.createTextNode("");
      this.selectedNode.appendChild(textnode);
    }

    // e.preventDefault();
  }

  // The contenteditable blur is not working for emailcontent models
  onFocusOut(event): void {
    console.log("ON FOCUS OUT CALLED");
    this.setSelectedData();
    const dbModel = { ...this.template };
    if (event.target.attributes["contenteditable"] !== undefined) {
      const model = event.target.attributes["ng-model"].nodeValue;
      if (model !== undefined) {
        dbModel[model.split(".")[1]] = this.contenteditableDirective.applyHtmlParsing(event.target.innerHTML);
      }
    }
    const templateUpdateModel = {
      updatedModel: dbModel,
      isModelUpdated: true,
      updateType: "model",
        type: "email"
    };
    this.store.dispatch(
      PreviewEditTemplateActions.templateUpdateModel({ templateUpdateModel })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.templateParameters !== undefined || changes.triggeredCategory !== undefined) {
      if (
        this.templateParameters !== undefined &&
        this.templateParameters.length !== 0
      ) {
        this.displayTemplateParameters = [...this.templateParameters];
          if (this.triggeredCategory === "orders") {
              const locationIndex = this.displayTemplateParameters.findIndex(templateParameter =>
                  templateParameter.label === 'location');
              this.displayTemplateParameters.splice(locationIndex, 4);
              const appointmentIndex = this.displayTemplateParameters.findIndex(
                  (templateParameter) => templateParameter.label === "appointment time"
              );
              this.displayTemplateParameters.splice(appointmentIndex, 4);
          }

        this.selectedTemplateParameter = this.templateParameters[0].value;
      }
    }

    if (changes.mailContent !== undefined) {
      if (this.mailContent !== undefined) {
        this.mailContent = this.mailContent.replaceAll(
          "{{job.editable}}",
          !this.isOnlyPreview
        );
        if (!this.isOnlyPreview) {
          this.mailContent = this.mailContent;
          //.replaceAll('contenteditable=', '[attr.contenteditable]=')
        }
        this.mailContent = this.mailContent
          .replaceAll(/&lt;/g, "<")
          .replaceAll(/&gt;/g, ">");

        if (this.imageModel !== undefined && this.imageModel.length > 0) {
          this.imageModel.forEach((model) => {
            const matches = this.mailContent.match(/(http)([^])*?([a-z])\w+"/g);
            let i = 0;
            const replaceWith = `${this.contextVariables[model.ngModel]}"`;
            if (matches !== 0 && matches !== null) {
              while (i !== matches.length) {
                if (matches[i].indexOf("template-context") !== -1) {
                  if (
                    matches[i].indexOf(
                      replaceWith.substr(replaceWith.lastIndexOf("/"))
                    ) !== -1
                  ) {
                    this.mailContent = this.mailContent.replace(
                      matches[i],
                      replaceWith
                    );
                  }
                }
                i++;
              }
            }
          });
        }
      }
    }

    if (changes.templateUpdateModel !== undefined && !this.preventChanges) {
      if (
        this.templateUpdateModel.updateType === "changeCategory" ||
        this.templateUpdateModel.updateType === "updatedJob" ||
        this.templateUpdateModel.updateType === "savedJob" ||
        this.templateUpdateModel.updateType === "setToDefault"
      ) {
        this.store.dispatch(
          PreviewEditTemplateActions.templateUpdateModel({
            templateUpdateModel: this.templateUpdateModel,
          })
        );
      }
    }
  }

  setSelectedData(): void {
    this.selection = {
      focusOffset: window.getSelection().focusOffset,
      focusNode: window.getSelection().focusNode,
    };
  }
}
